import { render, staticRenderFns } from "./EditorElementAdd.vue?vue&type=template&id=d97b718a&lang=pug"
import script from "./EditorElementAdd.vue?vue&type=script&lang=js"
export * from "./EditorElementAdd.vue?vue&type=script&lang=js"
import style0 from "./EditorElementAdd.vue?vue&type=style&index=0&id=d97b718a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports